<!--
 * @Author: DQL
 * @Date: 2020-03-18 10:31:17
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-27 18:44:18
 * @Description: 机构管理--查看机构信息
 -->
<template>
  <div class="l-page--inner l-page--detail">
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        详细信息
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <el-button
          type="succes"
          icon="kestrel-icon ki-plus"
          @click="handleAdd()"
        >
          新增下级组织
        </el-button>
        <el-button
          type="primary"
          icon="kestrel-icon ki-plus"
          :loading="relatedLwdwLoading"
          @click="handleRelatedLwdw()"
        >
          关联消防单位
        </el-button>
        <el-button
          type="success"
          icon="kestrel-icon ki-edit"
          plain
          :disabled="disabledEditDept"
          @click="handleClickSwitchToEdit()"
        >
          编辑
        </el-button>
        <el-button
          type="danger"
          icon="kestrel-icon ki-trash-o"
          :disabled="disabledEditDept"
          @click="handleDel()"
        >
          删除
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :inline="true"
          label-position="right"
          label-width="140px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              v-if="fd.parentDeptCode && fd.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织代码"
              >
                <span class="c-form__read">
                  {{ fd.parentDeptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              v-if="fd.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织名称"
              >
                <span class="c-form__read">
                  {{ fd.parentDeptName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织代码"
                prop="deptCode"
              >
                <span class="c-form__read">
                  {{ fd.deptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织名称"
                prop="deptName"
              >
                <span class="c-form__read">
                  {{ fd.deptName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                label="组织简称"
                class="c-form__item"
                prop="deptShortName"
              >
                <span class="c-form__read">
                  {{ fd.deptShortName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织标志"
                prop="deptTypeCode"
              >
                <span class="c-form__read">
                  {{ fd.deptTypeName }}
                </span>
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="所属区域"
                prop="AREA"
              >
                <span class="c-form__read">
                  {{ fd.AREA_NAME }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="公司地址"
                prop="GS_DZ"
              >
                <span class="c-form__read">
                  {{ fd.GS_DZ }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="法定代表人"
                prop="FDDBR"
              >
                <span class="c-form__read">
                  {{ fd.FDDBR }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="联系人"
                prop="LXR"
              >
                <span class="c-form__read">
                  {{ fd.LXR }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="LXDH"
              >
                <span class="c-form__read">
                  {{ fd.LXDH }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="传真"
                prop="CZ"
              >
                <span class="c-form__read">
                  {{ fd.CZ }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="邮编"
                prop="YB"
              >
                <span class="c-form__read">
                  {{ fd.YB }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="场地面积（m²）"
                prop="CD_MJ"
              >
                <span class="c-form__read">
                  {{ fd.CD_MJ }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="法人证件"
                prop="frzjFiles"
              >
                <image-upload-list
                  v-if="fd.FRZJ"
                  v-model="fd.frzjFiles"
                  multiple
                  disabled
                  list-type="picture-card"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="营业执照"
                prop="yyzzFiles"
              >
                <image-upload-list
                  v-if="fd.YYZZ"
                  v-model="fd.yyzzFiles"
                  multiple
                  disabled
                  list-type="picture-card"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="数据来源"
              >
                <span class="c-form__read">
                  {{ fd.sourceTypeName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="关联消防单位"
              >
                <!-- 以逗号拼接的方式展示关联的消防单位名称 -->
                <span
                  v-if="relatedLwdwList && relatedLwdwList.length > 0"
                  class="c-form__read"
                >
                  {{ relatedLwdwNames }}
                </span>
                <span
                  v-else
                  class="c-form__read"
                  style="color: #999;"
                >
                  暂无关联消防单位
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->

    <!-- 关联消防单位对话框 Start -->
    <el-dialog
      title="关联消防单位"
      :visible.sync="lwdwDialogVisible"
      width="800px"
      :close-on-click-modal="true"
      append-to-body
    >
      <el-form>
        <el-form-item label="选择消防单位：">
          <el-select
            v-model="selectedLwdw"
            placeholder="请选择消防单位（可多选）"
            filterable
            multiple
            popper-append-to-body
            style="width: 100%"
          >
            <el-option
              v-for="item in lwdwList"
              :key="item.dwbm"
              :label="item.dwmc"
              :value="item.dwbm"
            >
              <span style="float: left">{{ item.dwmc }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.ssqy }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="lwdwDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSaveLwdw"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 关联消防单位对话框 End -->
  </div>
</template>

<script>
import { deptService } from '../dept.service';

export default {
  name: 'AttrViewDept',
  props: {
    deptCode: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean
    },
    // 扩展字段列表
    attrDeptList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data () {
    return {
      /* 表单参数 Start */
      fd: {
        parentDeptCode: null,
        parentDeptName: null,
        deptCode: null,
        deptName: null,
        deptShortName: null,
        deptTypeCode: null,
        effectStartDate: null,
        effectEndDate: null,
        source: null,
        TYSHXYDM: null,
        LXR: null,
        LXDH: null,
        CZ: null,
        YB: null,
        YYZZ: [],
        AREA: null,
        AREA_NAME: null,
        GS_DZ: null,
        FDDBR: null,
        CD_MJ: null,
        FRZJ: null,
        frzjFiles: [],
        yyzzFiles: []
      },
      /* 表单参数 End */
      /* 消防单位关联相关 Start */
      relatedLwdwLoading: false,
      lwdwDialogVisible: false,
      lwdwList: [],
      relatedLwdwList: [],
      selectedLwdw: []
      /* 消防单位关联相关 End */
    };
  },
  computed: {
    // 禁止编辑的机构部门
    disabledEditDept () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_SOURCE_TYPE) {
        return this.fd.source === enums.BASE_SOURCE_TYPE.ENUM_KEY_1.id;
      }
      return false;
    },
    // 将关联的消防单位名称以逗号拼接
    relatedLwdwNames () {
      if (this.relatedLwdwList && this.relatedLwdwList.length > 0) {
        return this.relatedLwdwList.map(item => item.dwmc).join(',');
      }
      return '';
    }
  },
  methods: {
    /**
     * @description: 获取组织信息
     * @param {*}
     * @return {*}
     */
    getDeptInfo () {
      const _this = this;
      // 回调页面开启loading状态
      _this.$emit('update:isLoading', true);
      deptService.get(this.deptCode)
        .then(rsp => {
          // 此处修改为不使用Object.assign赋值，
          // 是避免切换组织机构后的扩展字段枚举类的没有值，沿用了上一个组织机构的值
          _this.fd = rsp.data;
          this.$set(_this.fd, 'frzjFiles', rsp.data.FRZJ ? rsp.data.FRZJ.split(';') : []);
          this.$set(_this.fd, 'yyzzFiles', rsp.data.YYZZ ? rsp.data.YYZZ.split(';') : []);
        })
        .catch(err => {
          console.error('获取组织机构数据出错', err);
        })
        .finally(() => {
          // 回调页面开启loading状态
          _this.$emit('update:isLoading', false);
        });
    },
    /**
     * @description: 触发切换页面状态为新增
     * @param {*}
     * @return {*}
     */
    handleAdd () {
      this.$emit('switch', 'addDept');
    },
    /**
     * @description: 触发切换页面状态为编辑
     * @param {*}
     * @return {*}
     */
    handleClickSwitchToEdit () {
      this.$emit('switch', 'editDept');
    },
    /**
     * @description: 删除
     * @param {*}
     * @return {*}
     */
    handleDel () {
      const _this = this;
      _this.$confirm(`是否删除组织【${_this.fd.deptName}】？`, '提示', { type: 'warning' })
        .then(() => {
          deptService.delete(_this.fd.deptCode)
            .then(rsp => {
              _this.$alert('删除成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              // 回调重载页面
              _this.$emit('delReload');
            })
            .catch(err => {
              console.error('删除错误！', err);
            });
        });
    },
    /**
     * @description: 打开关联消防单位对话框，并回显已关联的消防单位
     * @param {*}
     * @return {*}
     */
    handleRelatedLwdw () {
      const _this = this;
      if (!_this.deptCode) {
        _this.$message.warning('请先选择部门');
        return;
      }
      _this.relatedLwdwLoading = true;
      // 获取消防单位列表
      deptService.getLwdwList()
        .then(rsp => {
          if (rsp.data && rsp.data.data) {
            _this.lwdwList = rsp.data.data;
            // 回显已关联的消防单位编码
            _this.selectedLwdw = _this.relatedLwdwList.map(item => item.dwbm);
            _this.lwdwDialogVisible = true;
          }
        })
        .catch(err => {
          console.error('获取消防单位列表失败', err);
          _this.$message.error('获取消防单位列表失败');
        })
        .finally(() => {
          _this.relatedLwdwLoading = false;
        });
    },
    /**
     * @description: 保存消防单位关联，支持直接修改（计算差异后执行删除和新增）
     * @param {*}
     * @return {*}
     */
    handleSaveLwdw () {
      const _this = this;

      // 获取已关联的消防单位编码集合
      const oldDwbmSet = new Set(_this.relatedLwdwList.map(item => item.dwbm));
      // 获取当前选择的消防单位编码集合
      const newDwbmSet = new Set(_this.selectedLwdw);

      // 计算需要删除的（之前有但现在没选的）
      const toDelete = _this.relatedLwdwList
        .filter(item => !newDwbmSet.has(item.dwbm))
        .map(item => item.dwbm);

      // 计算需要新增的（现在选了但之前没有的）
      const toAdd = _this.selectedLwdw.filter(dwbm => !oldDwbmSet.has(dwbm));

      // 如果没有任何变化
      if (toDelete.length === 0 && toAdd.length === 0) {
        _this.$message.info('关联关系未发生变化');
        _this.lwdwDialogVisible = false;
        return;
      }

      // 构建异步任务数组
      const tasks = [];

      // 添加删除任务
      toDelete.forEach(dwbm => {
        tasks.push(deptService.deleteLwdwRelation(_this.deptCode, dwbm));
      });

      // 添加新增任务（如果有需要新增的单位，使用批量接口）
      if (toAdd.length > 0) {
        tasks.push(deptService.batchSaveLwdwRelation(_this.deptCode, toAdd));
      }

      // 执行所有任务
      Promise.all(tasks)
        .then(() => {
          const deleteMsg = toDelete.length > 0 ? `删除 ${toDelete.length} 个` : '';
          const addMsg = toAdd.length > 0 ? `新增 ${toAdd.length} 个` : '';
          const msg = [deleteMsg, addMsg].filter(Boolean).join('，');
          _this.$message.success(`关联关系更新成功（${msg}）`);
          _this.lwdwDialogVisible = false;
          // 重新加载关联列表
          _this.getRelatedLwdwList();
        })
        .catch(err => {
          console.error('更新关联关系失败', err);
          _this.$message.error('更新关联关系失败');
        });
    },
    /**
     * @description: 获取部门关联的消防单位列表
     * @param {*}
     * @return {*}
     */
    getRelatedLwdwList () {
      const _this = this;
      if (!_this.deptCode) {
        return;
      }
      deptService.getDeptRelatedLwdw(_this.deptCode)
        .then(rsp => {
          console.log('查询关联消防单位响应数据:', rsp);
          console.log('rsp.data:', rsp.data);
          if (rsp.data && rsp.data.data) {
            _this.relatedLwdwList = rsp.data.data;
            console.log('已关联的消防单位列表:', _this.relatedLwdwList);
          } else if (rsp.data) {
            // 兼容处理：如果返回格式是 { data: [...] }
            _this.relatedLwdwList = rsp.data;
            console.log('已关联的消防单位列表(兼容格式):', _this.relatedLwdwList);
          } else {
            console.warn('未找到关联数据');
            _this.relatedLwdwList = [];
          }
        })
        .catch(err => {
          console.error('获取关联消防单位列表失败', err);
        });
    }
  },
  watch: {
    deptCode: function (newVal) {
      if (newVal) {
        this.getDeptInfo();
        this.getRelatedLwdwList();
      }
    }
  },
  created () {
    if (this.deptCode) {
      this.getDeptInfo();
      this.getRelatedLwdwList();
    }
  }
};
</script>

<style>
</style>
